export enum OffcanvasDismissEnum {
    Background = 0, // comes from the NgbOffcanvas
    CrossClick = 'Cross click', // comes from the NgbOffcanvas
    Apply = 1,
    Clear = 2
  }